<template>
  <div class="ml-n3">
    <div
      class="pointer-true mb-1 d-flex border palette-cell bg-light rounded"
      :class="[{'selected-cell': selected == 'brush'}]"
      @click="ChangeTool('brush')"
    >
      <img class="m-auto select-none" width="16" height="16" src="@/assets/image/brush_0.png" alt="Стерка" />
    </div>
    <div
      class="pointer-true mb-1 d-flex border palette-cell bg-light rounded"
      :class="[{'selected-cell': selected == 'erase'}]"
      @click="ChangeTool('erase')"
    >
      <img class="m-auto select-none" width="14" height="14" src="@/assets/image/erase_0.png" alt="Стерка" />
    </div>
    <div
      class="pointer-true mb-1 d-flex border palette-cell bg-light rounded"
      :class="[{'selected-cell': selected == 'fill'}]"
      @click="ChangeTool('fill')"
    >
      <img class="m-auto select-none" width="16" height="16" src="@/assets/image/fill_0.png" alt="Стерка" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "brush",
      lastTool: "brush"
    };
  },
  beforeMount() {
    document.addEventListener("keyup", this.KeyHandler);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.KeyHandler);
  },
  methods: {
    KeyHandler(e) {
      let k = e.keyCode;
      // num 1 || E
      if (k == 97 || k == 69)
        this.ChangeTool(this.selected == "erase" ? this.lastTool : "erase");
      // num 2 || F
      else if (k == 98 || k == 70)
        this.ChangeTool(this.selected == "fill" ? this.lastTool : "fill");
    },
    ChangeTool(name) {
      this.lastTool = this.selected;
      this.selected = name;
      this.$emit("change_tool", name);
    }
  }
};
</script>

<style scoped>
.selected-cell {
  border: 2px solid #aaa;
  box-shadow: 0px 0px 3px 1px #00aeff;
  width: 32px;
  height: 32px;
}
.palette-cell {
  max-width: 32px;
  max-height: 32px;
  width: 30px;
  height: 30px;
}
</style>